import type { ColumnDefinition } from "@frui.ts/dataviews";
import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import type BankAccountBlacklist from "entities/bankAccountBlacklist";
import { formatDateTime } from "utils/localizations";
import BankAccountBlacklistsViewModel from "viewModels/finance/bankAccountBlacklists/bankAccountBlacklistsViewModel";
import ListView from "../../common/list";
import { formatBankAccount } from "@edaz/utils/bankAccount";

const BankAccountBlacklistsView: ViewComponent<BankAccountBlacklistsViewModel> = observer(({ vm }) => {
  const cellClassName = "text-nowrap";

  const columns: ColumnDefinition<BankAccountBlacklist>[] = [
    {
      title: vm.translateAttribute("bankAccount"),
      property: "bankAccount",
      cellClassName,
      valueFormatter: props => formatBankAccount(props.value),
    },
    {
      title: vm.translateAttribute("description"),
      property: "description",
      cellClassName,
      valueFormatter: props => formatDateTime(props.value),
    },
  ];

  return <ListView columns={columns} vm={vm} showDetailWithList={true} />;
});

registerView(BankAccountBlacklistsView, BankAccountBlacklistsViewModel);
